// extracted by mini-css-extract-plugin
export default {"main":"TemplateHeaders_main__oiKfG","actions":"TemplateHeaders_actions__tQJRc"};